import { createSelector } from '@ngrx/store';
import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { projectsAdapter, ProjectsState } from './projects.reducer';

export const getProjectsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => state?.projects,
);

export const getSelectedProjectId = createSelector(
  getProjectsState,
  (state: ProjectsState) => state.projectSelectedId,
);

export const getIsLikedTabActive = createSelector(
  getProjectsState,
  (state: ProjectsState) => state.isLikedTabActive,
);

export const {
  selectIds: getProjectsIds,
  selectEntities: getProjectsEntities,
  selectAll: getProjectsAll,
  selectTotal: getProjectsTotal,
} = projectsAdapter.getSelectors(getProjectsState);

export const getProjectsLoading = createSelector(getProjectsState, (state) => state?.loading);

export const getSelectedProject = createSelector(
  getProjectsEntities,
  getSelectedProjectId,
  (entities, selectedId) => {
    if (!selectedId) {
      return null;
    }
    return entities[selectedId] ?? null;
  },
);

export const getIsAgentDockVisible = createSelector(
  getIsLikedTabActive,
  (isLikedTabActive) => !isLikedTabActive,
);

export const getBarChartData = createSelector(
  getProjectsState,
  (state: ProjectsState) => state.barChartData,
);
